export const menuList = {
    "COURSES": "Dersler",
    "TRAILS": "Patikalar",
    "PLATFORM_APPLICATIONS": "Platform Uygulamaları",
  }